import React from 'react';
import styled from 'styled-components/macro';

const LayoutWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  margin-bottom: 15px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
`;

const LayoutRowOne = styled.div`
  margin: 20px;
`;

const LayoutRowTwo = styled.div`
  padding: 20px 0 20px;
  white-space: nowrap;

  > div {
    width: 50%;
    margin: 0 auto;
  }
`;

interface TwoRowsLayoutOwnProps {
  upperRow: JSX.Element | null;
  bottomRow: JSX.Element | null;
}

const TwoRowsLayout = ({ bottomRow, upperRow }: TwoRowsLayoutOwnProps) => {
  return (
    <LayoutWrapper id="scroller">
      <LayoutRowOne>{upperRow}</LayoutRowOne>
      <LayoutRowTwo>{bottomRow}</LayoutRowTwo>
    </LayoutWrapper>
  );
};

export default TwoRowsLayout;
